/** Indica se a URL vai para a API Professor via reverse proxy (ou host legado). */
export function isProxiedApiUrl(url: string): boolean {
  if (url.includes('apiprofessor.ergonsistemas')) {
    return true;
  }

  // IBGE e outras APIs públicas também usam o path `/api/...`.
  // Só o prefixo relativo same-origin é o reverse proxy deste app.
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return false;
  }

  const path = url.split('?')[0];
  return path === '/api' || path.startsWith('/api/');
}
